const libPictView = require('pict-view');
/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class Inspection extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		/** @type {any} */
		this.options;

		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideIfEqual:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			return tmpValue == tmpCompare ? 'is-hidden' : '';
		});

		this.pict.MetaTemplate.addPattern('{~BitElse:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpTrue, tmpFalse ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			return tmpValue == '1' ? tmpTrue : tmpFalse;
		});

		// add the ".is-hidden" class to the Select a Bridge  title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~HideForBridge:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			const tmpLocked = this.pict.AppData?.DocumentData?.ReportData?.Locked;
			return tmpValue && tmpValue !== tmpCompare || tmpLocked === 1 ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the Add To Inspection btn if the passed value is false
		this.pict.MetaTemplate.addPattern('{~HideForInspection:', '~}', (pHash, pData, fCallback) =>
		{
			const [ tmpHash, tmpCompare ] = pHash.split('^');
			const tmpValue = this.pict.resolveStateFromAddress(tmpHash, pData, fCallback);
			const tmpLocked = this.pict.AppData?.DocumentData?.ReportData?.Locked;
			const tmpDocument = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			// if there is no document, dont allow to add inspections
			return tmpValue && tmpValue > tmpCompare && tmpLocked === 0 && tmpDocument ? '' : 'is-hidden';
		});
	}

	includeChangeHandler(pID)
	{
		this.log.info(`includeChangeHandler: ${pID}`);
		if (!this.pict.AppData.CurrentInspection)
		{
			this.log.error(`No Current Inspection set; can't update include state for document ${pID}.`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Current Inspection set; can't update include state for document: ${pID}.`,
				type: 'is-danger',
			});
			return;
		}
		const tmpDocumentID = pID.split('_')[1];
		if (!tmpDocumentID)
		{
			return;
		}
		const tmpDocument = this.AppData.InspectionDocumentRecords?.find?.((pRecord) => pRecord.IDDocument == tmpDocumentID);
		const tmpCheckbox = document.getElementById(pID);
		const tmpInclude = tmpCheckbox instanceof HTMLInputElement && tmpCheckbox.checked;
		if (tmpDocument)
		{
			tmpDocument.IncludeOnDossier = tmpInclude ? 1 : 0;
		}
		this.pict.BridgeDocumentManager.includeDocumentInInspectionDossier(tmpDocumentID, this.pict.AppData.CurrentInspection.IDInspection, tmpInclude)
		.catch((pError) =>
		{
			this.log.error(`Error updating inspection dossier include state.`, pError);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Error updating inspection dossier.`,
				type: 'is-danger',
			});
		});
	}

	/**
	 * Set Current Inspection Type
	 * @param {object} event - The click event
	 */

	getCurrentType(event)
	{
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}
		// get current inspection type
		const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
		if (inspectionTypeSelector instanceof HTMLSelectElement)
		{
			const currentInspectionType = this.AppData.InspectionTypes?.find((pType) => pType.IDInspectionType == inspectionTypeSelector.value);
			// set current inspection type name
			this.currentInspectionTypeName = currentInspectionType.Name;
			// update current inspection type based on selection on Current Inspection
			this.AppData.CurrentInspection.IDInspectionType = inspectionTypeSelector.value;
			// update current inspection name in report data based on selection
			this.AppData.DocumentData.ReportData.FormData.CurrentInspection.Type = this.currentInspectionTypeName;
			this.pict.log.info('Current Document FormData:', this.AppData.DocumentData?.ReportData?.FormData);
		}
	}


	inspectionTypeChangeHandler(event)
	{
		if (!this.pict.AppData.CurrentInspection)
		{
			this.log.error(`No Current Inspection set; can't update inspection type for inspection: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Current Inspection set; can't update inspection type for inspection: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
			if (inspectionTypeSelector instanceof HTMLSelectElement)
			{
				// enable inspection type selector
				inspectionTypeSelector.disabled = false;
			}
			if (document.getElementById('CurrentInspection-Type-Button'))
			{
				// change edit aesthetics to save aesthetics
				document.getElementById('CurrentInspection-Type-Button').classList.remove('is-link');
				document.getElementById('CurrentInspection-Type-Button').classList.add('is-success');
				document.getElementById('CurrentInspection-Type-Icon').classList.remove('fa-pencil');
				document.getElementById('CurrentInspection-Type-Icon').classList.add('fa-save');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('title', 'Save Inspection Type');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('onclick', '_Pict.views.Inspection.confirmInspectionType()');
			}
		}
	}

	/**
	 * Confirmation Modal to save the form with the new Inspection Type
	 */
	confirmInspectionType()
	{
		// the body and footer templates for the confirmation modal
		const confirmModalBodyTemplate = /*html*/`
		<span id="ConfirmModalBody">
			<div class="column is-12">
				<div class="field">
					<p class="subtitle is-6 has-text-centered">The Inspection Type will be changed from <strong>${this.existingInspectionTypeName}</strong> to <strong>${this.currentInspectionTypeName}</strong> for form <strong>${this.AppData.CurrentInspection.Name}</strong>.</p>
					<p class="subtitle is-6 has-text-centered">Please click button below to save or close this modal.</p>
				</div>
			</div>
		</span>`;
		const confirmModalFooterTemplate = /*html*/`
		<div id="ConfirmModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Save" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Save Inspection Type" onclick="_Pict.views.Inspection.confirmSaveCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Save</span>
			</button>
		</div>`;
		// the options for the confirmation modal
		const confirmModalOptions = {
			title: 'Save Inspection Type?',
			modalBodyTemplate: confirmModalBodyTemplate,
			modalFooterTemplate: confirmModalFooterTemplate,
			confirmText: 'Save',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(confirmModalOptions, this.confirmSaveCallback.bind(this));
	}

	/**
	 * Callback to run when user confirms inspection type save
	 * @param {object} event - The click event
	 */
	async confirmSaveCallback(event)
	{
		if (event)
		{
			// show save spinner
			event.target.innerHTML = '<span class="icon"><i class="fas fa-fw fa-spinner fa-spin" aria-hidden="true"></i></span>';
		}
		// update bridge current inspection
		await this.pict.providers.BridgeProvider.updateBridgeInspection(this.pict.AppData.CurrentInspection)
		.catch((pError) =>
		{
			this.log.error(`Error updating inspection type.`, pError);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Error updating inspection type.`,
				type: 'is-danger',
			});
		});
		await this.pict.providers.DocumentProvider.handleSave();
		if (event)
		{
			// change save spinner back to save text
			event.target.innerHTML = '<span class="icon"><i class="fas fa-fw fa-save" aria-hidden="true"></i></span><span>Save</span>';
			this.pict.fable.services.HeadlightModal.dismissModals();
			this.log.info(`Inspection type update successful.`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `Inspection type has been updated.`,
				type: 'is-success',
			});
			const inspectionTypeSelector = document.getElementById('CurrentInspection-Type-Selector');
			if (inspectionTypeSelector instanceof HTMLSelectElement)
			{
				// disable inspection type selector after successful save
				inspectionTypeSelector.disabled = true;
			}
			if (document.getElementById('CurrentInspection-Type-Button'))
			{
				// change save aesthetics back to edit aesthetics
				document.getElementById('CurrentInspection-Type-Button').classList.remove('is-success');
				document.getElementById('CurrentInspection-Type-Button').classList.add('is-link');
				document.getElementById('CurrentInspection-Type-Icon').classList.remove('fa-save');
				document.getElementById('CurrentInspection-Type-Icon').classList.add('fa-pencil');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('title', 'Edit Inspection Type');
				document.getElementById('CurrentInspection-Type-Button').setAttribute('onclick', '_Pict.views.Inspection.inspectionTypeChangeHandler(event)');
			}
			// update inspection type values
			this.initializeInspectionTypeSelect();
			// render the current state of the document data
			this.pict.views.BridgeSelection.renderAsync(() =>
			{
				this.pict.log.info('Bridge Selection Rendered');
			});
		}
	}

	invalidate()
	{
		delete this.AppData.InspectionDocumentRecords;
		delete this.AppData.CachedInspectionDocumentRecordsIDInspection;
	}

	onBeforeRenderAsync(fCallback, pRenderable)
	{
		super.onBeforeRenderAsync(async () =>
		{
			const noInspectionSet = !this.pict.AppData.CurrentInspection && this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			const cacheDeleted = !this.AppData.CachedInspectionDocumentRecordsIDInspection && !this.AppData.InspectionDocumentRecords;
			if (noInspectionSet || cacheDeleted)
			{
				try
				{
					await this.pict.providers.InspectionProvider.getCurrentInspectionDocuments(this.pict.AppData?.DocumentData?.ReportData?.IDDocument);
				}
				catch (pError)
				{
					this.log.error('Error loading current Inspection Documents.', pError);
					this.pict.views.HeadlightPanels?.toast?.({
						message: `Error loading current Inspection Documents.`,
						type: 'is-danger',
					});
					return fCallback(pError);
				}
			}
			else
			{
				this.log.info('Current Inspection already set, skipping loading from Document.');
			}
			fCallback();
		}, pRenderable);
	}

	/**
	 * Adds the current document to inspection selected.
	 */
	async setCurrentInspection()
	{
		//there is no Inspection associated with the document yet
		//check if an inspection is selected
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection') || this.pict.views.Inspection.CurrentSearchFilters.Inspection;
		if (selectedInspection)
		{
			const inspectionID = selectedInspection.toString();
			const documentID = this.pict.AppData?.DocumentData?.ReportData?.IDDocument;
			if (documentID)
			{
				const newInspectionDoc = await this.pict.BridgeDocumentManager.addDocumentToInspection(documentID, inspectionID, true);
				if (newInspectionDoc)
				{
					this.pict.views.HeadlightPanels?.toast?.({
						message: `Document has been added to Inspection.`,
						type: 'is-success',
					});
					this.pict.views.Inspection.renderAsync(() =>
					{
						this.log.info('Current Inspection rendered');
					});
				}
			}
		}
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 */
	updateSelectedInspection()
	{
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection');
		if (selectedInspection)
		{
			this.pict.ContentAssignment.removeAttribute('#buttonAddToInspection', 'disabled');
			this.pict.views.Inspection.CurrentSearchFilters.Inspection = selectedInspection;
		}
	}
	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		this.initializeInspectionTypeSelect();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Add a Document to the current Inspection
	 */
	addDocumentToInspection()
	{
		this.pict.views.HeadlightPanels.handlePanelToggle('Documents');
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-DocumentPanel').setAttribute('data-panel-mode', 'add-to-inspection');
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-inspection';
		this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-inspection';
		this.pict.views.DocumentSearch.setMode('add-to-inspection');
		// set the banner on the header that you are adding an Document
		document.getElementById('HeadlightPanels-DocumentPanel-Document-Header-Mode-Target').innerText = this.AppData.CurrentInspection.Name || ' the current inspection';
	}

	resetInspectionView()
	{
		this.invalidate();
		this.pict.views.Inspection.renderAsync(() =>
		{
			this.log.info('Inspection rendered');
		});
	}

	/**
	 * Validate changes before closing the panel
	 * @param {object} event
	 */
	handleClosePanelEvent(event)
	{
		const selectedInspection = this.pict.ContentAssignment.readContent('#Inspection');
		if (selectedInspection && !this.pict.AppData?.DocumentData?.ReportData?.CurrentInspection)
		{
			this.fable.HeadlightModal.spawnMiniModal(
				{
					...this.fable.HeadlightModal.MiniModalPreset,
					message: 'Close Current Inspection Panel?',
				},
				() =>
				{
					this.pict.HeadlightPanels.leftPanelHide();
					this.pict.views.Inspection.resetInspectionView();
				},
			null);
		}
		else
		{
			this.pict.views.HeadlightPanels.closeThisPanel(event);
		}
	}

	/**
	 * Add a form to an inspection
	 */
	addFormToInspection()
	{
		this.pict.ContentAssignment.removeClass('#InspectionSelector', 'is-hidden');
		this.pict.ContentAssignment.removeClass('#buttonAddToInspection', 'is-hidden');
		this.pict.ContentAssignment.setAttribute('#buttonShowInspections', 'disabled', 'disabled');
		const tmpInspection = this.AppData?.DocumentData?.ReportData?.CurrentInspection ? { id: this.AppData?.DocumentData?.ReportData?.CurrentInspection.IDInspection, text: this.AppData?.DocumentData?.ReportData?.CurrentInspection?.Name } : null;
		const tmpProject = this.AppData?.DocumentData?.ReportData?.Project?.IDProject ? this.AppData?.DocumentData?.ReportData?.Project?.IDProject : null;
		//this.pict.providers.InspectionSelector.initializeSelect2('Inspection', tmpBridge );
		this.initializeSelect2Plugin({
			IDProject: tmpProject,
			dropdownCssClass: 'theme-dark' + (tmpInspection ? ' has-sticky-option' : ''),
			placeholder: 'Search by Inspections...',
			ElementID: 'Inspection',
			ParentID: 'InspectionSelector',
			URL: 'Inspections',
			IDField: 'IDInspection',
			TextField: 'Name',
			StickyOption: tmpInspection,
			PreselectOption: tmpInspection,
		}, () =>
		{
			this.log.info('Select2 Inspection initialized');
		});
	}


	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		if (window['jQuery'] && window['jQuery'].fn.select2)
		{
			const tmpSelectOptions = this.pict.providers.Select2Util.getOptionsAjax('Inspection',
				{
					Input: pOptions.ElementID,
					SearchFields: [ 'Name' ],
					AllowClear: false,
					SearchFallbackPlaceholder: 'Enter a inspection name ...',
					HandleSearchFilters: (pFilters) =>
					{
						if (!pOptions.IDProject)
						{
							return pFilters;
						}
						if (pFilters.length > 0)
						{
							pFilters.unshift('FOP~0~(~0');
							pFilters.push('FCP~0~)~0');
						}
						pFilters.push(`FBV~IDProject~EQ~${pOptions.IDProject}`);
						return pFilters;
					},
				});
			// if the select2 plugin is not already initialized, initialize it now for the correct input type
			if (!window['jQuery'](`#${pOptions.ElementID}`).data('select2'))
			{
				//NOTE:has to be attached to a Parent for the drop down to show
				window['jQuery'](`#${pOptions.ElementID}`).select2(Object.assign( { dropdownParent: `#${pOptions.ParentID}` }, tmpSelectOptions));
			}
		}

		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}
	/**
	 * Initialize the Inspection Type Selector
	 */

	initializeInspectionTypeSelect()
	{
		const tmpSelect = document.getElementById('CurrentInspection-Type-Selector');
		if (tmpSelect instanceof HTMLSelectElement)
		{
            tmpSelect.value = this.pict.AppData.CurrentInspection.IDInspectionType;
            const existingInspectionType = this.AppData.InspectionTypes?.find((pType) => pType.IDInspectionType == tmpSelect.value);
			this.existingInspectionTypeName = existingInspectionType.Name;
		}
	}
}

const _ViewConfiguration = (
	{
		ViewIdentifier: 'HeadlightPanels-Inspection',
		DefaultRenderable: 'HeadlightPanels-Inspection',
		DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
		AutoRender: true,
		CSS: '',
		Templates: [
			{
				Hash: 'Datum-Value-Name',
				Template: /*html*/`{~D:Record.Name~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Wrapper',
				Template: /*html*/`
				<article id="HeadlightPanels-Inspection" class="panel is-active panel-content panel-has-nested-scroll-content">
					<p id="HeadlightPanels-Inspection-Header" class="panel-heading pr-4">
						<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.Inspection.handleClosePanelEvent(event);">
							<span class="icon">
								<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
							</span>
						</button>
						<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
							<span class="icon">
								<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
							</span>
						</button>
						<span class="icon">
							<i id="HeadlightPanels-Inspection-Icon" class="fas fa-fw fa-building-magnifying-glass" aria-hidden="true"></i>
						</span>
						<span id="HeadlightPanels-Inspection-Header-Title" class="mr-3">Current Inspection</span>
					</p>
					<div class="column nested-scroll-content has-bottom-navbar-offset">
						{~TIfAbs:HeadlightPanels-Inspection-Empty:AppData.CurrentInspection:AppData.CachedInspectionDocumentRecordsIDInspection^==^0~}
						{~TIfAbs:HeadlightPanels-Inspection-Content:AppData.CurrentInspection:AppData.CachedInspectionDocumentRecordsIDInspection^>^0~}
					</div>
				</article>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Empty',
				Template: /*html*/`
				<div class="notification is-dark has-text-grey has-text-centered {~Show:Pict.AppData.DocumentData.ReportData.Locked~}">
					<span class="icon">
						<i class="fas fa-info-circle"></i>
					</span>
					<span class="icon-text">Document is locked.</span>
				</div>
				<div class="is-dark has-text-grey has-text-centered {~HideForInspection:Pict.AppData.DocumentData.ReportData.Project.IDProject^0~}">
					<button id="buttonShowInspections" class="button is-fullwidth is-primary" type="button" title="Add to inspection" onclick="_Pict.views.Inspection.addFormToInspection()">
						<span class="icon">
							<i class="fas fa-fw fa-plus" aria-hidden="true"></i>
						</span>
						<span>Add to Inspection</span>
					</button>
					<div>
						{~T:HeadlightPanels-Inspection-InspectionSelector~}
						<button id="buttonAddToInspection" class="button is-centered is-primary pt-2 is-hidden" disabled type="button" title="Save" onclick="_Pict.views.Inspection.setCurrentInspection()">
							<span class="icon">
								<i class="fas fa-fw fa-save" aria-hidden="true"></i>
							</span>
							<span>Save</span>
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-InspectionSelector',
				Template: /*html*/`
				<div id="InspectionSelector" class="column is-hidden theme-dark">
					<div class="field" style="margin-bottom: 10px;">
						<label class="label block" for="Inspection">Inspections</label>
						<div class="control control-status select is-fullwidth">
							<select
								id="Inspection"
								onchange="_Pict.views.Inspection.updateSelectedInspection('Inspection')"
							>{~TS:HeadlightPanels-Inspection-InspectionSelector-SelectedOptions:Context[0].CurrentSearchFilters.Inpsection~}</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Content',
				Template: /*html*/`
				
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-20">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:AppData.CurrentInspection.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">#{~D:AppData.CurrentInspection.IDInspection~}</p>
					</div>
				</div>
				{~T:HeadlightPanels-Inspection-Details:AppData.CurrentInspection~}
				{~T:HeadlightPanels-Inspection-Documents:AppData.InspectionDocumentRecords~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-Empty',
				Template: /*html*/`
				<tr>
					<td colspan="3" class="has-text-centered">
						<div class="notification is-dark">
							<span class="icon">
								<i class="fas fa-info-circle"></i>
							</span>
							<span class="icon-text">No inspection documents found.</span>
						</div>
					</td>
				</tr>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Details',
				Template: /*html*/`
				<div id="InspectionType-Details" data-theme="dark" class="columns m-0 px-3 my-3">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.StatusDisplay~}</span>
					</div>
					<div class="column is-6">
						<div class="field">
							<label class="title is-block is-6 has-text-text-60" for="CurrentInspection-Type-Selector">Type</label>
							{~T:HeadlightPanels-Inspection-Type-Selector~}
						</div>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^ObservationDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Scheduled Start Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.ScheduledStartDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Deadline Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DeadlineDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Description</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Description~}</span>
					</div>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents',
				Template: /*html*/`
				<h3 class="title has-text-text-90 is-5 p-0 m-0 ml-1 mb-2">Inspection Documents</h3>
				<table class="table is-striped is-hoverable is-fullwidth mb-2">
					<thead>
						<tr>
							<th class="has-text-centered">Included in Dossier</th>
							<th colspan="2">Name</th>
						</tr>
					</thead>
					<tbody>
						{~TIfAbs:HeadlightPanels-Inspection-Documents-Empty:AppData.InspectionDocumentRecords:AppData.InspectionDocumentRecords.length^==^0~}
						{~TIfAbs:HeadlightPanels-Inspection-Documents-List:AppData.InspectionDocumentRecords:AppData.InspectionDocumentRecords.length^>^0~}
					</tbody>
				</table>
				<button class="button is-fullwidth is-primary" type="button" title="Add document to inspection" onclick="_Pict.views.Inspection.addDocumentToInspection()">
					<span class="icon">
						<i class="fas fa-fw fa-plus" aria-hidden="true"></i>
					</span>
					<span>Add Document to Inspection</span>
				</button>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-List',
				Template: /*html*/`
				{~TS:HeadlightPanels-Inspection-Documents-List-Entry:Record~}`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Documents-List-Entry',
				Template: /*html*/`
				<tr id="DocumentRow_{~D:Record.IDDocument~}">
					<td class="is-vcentered has-text-centered">
						<div class="{~HideIfEqual:Record.DocumentType^Inspection-Dossier~}">
							<input type="checkbox" title="Toggle for Dossier inclusion" class="is-checkbox is-success" id="Include_{~D:Record.IDDocument~}" name="document" {~BitElse:Record.IncludeOnDossier^checked^~} onchange="_Pict.views.Inspection.includeChangeHandler(id)">
						</div>
					</td>
					<td class="is-vcentered">{~D:Record.Name~}</td>
					<td class="is-vcentered has-text-right">
						<button class="button is-ghost has-text-primary-75" type="button" title="Open document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocumentHandler(event, '{~D:Record.IDDocument~}')">
							<span class="icon">
								<i class="fas fa-fw fa-edit" aria-hidden="true"></i>
							</span>
							<span>Open</span>
						</button>
					</td>
				</tr>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Type-Selector',
				Template: /*html*/`
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<select 
							id="CurrentInspection-Type-Selector"
							onchange="_Pict.views.Inspection.getCurrentType(event)"
							disabled
						>
						{~TS:HeadlightPanels-Inspection-Types:AppData.InspectionTypes~}
						</select>
					</p>
					<p class="control">
						<button id="CurrentInspection-Type-Button" class="button is-link" type="button" title="Edit Inspection Type" onclick="_Pict.views.Inspection.inspectionTypeChangeHandler(event)">
							<span class="icon is-small">
								<i id="CurrentInspection-Type-Icon" class="fas fa-pencil"></i>
							</span>
						</button>
					</p>
				</div>`,
			},
			{
				Hash: 'HeadlightPanels-Inspection-Types',
				Template: /*html*/`
				<option value="{~D:Record.IDInspectionType~}">{~D:Record.Name~}</option>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'HeadlightPanels-Inspection',
				TemplateHash: 'HeadlightPanels-Inspection-Wrapper',
			},
		],
	});


module.exports = Inspection;

module.exports.default_configuration = _ViewConfiguration;
